import i18n from "i18next";
import { toast } from "react-toastify";

import { OVERRIDEN_ERROR_MESSAGES } from "./overriden-error-messages";
import { LoadResponse } from "../../models/api/load/load.response";
import { SaveResponse } from "../../models/api/save/save.response";
import { DTOModel } from "../../models/base/dto-model";

export const toastifyResponse = (
  response: SaveResponse | LoadResponse<DTOModel>,
  showMessages: "all" | "failed" = "all",
  successMessage = "default_success_message",
  cancellationMessage = "default_cancellation_message",
  errorMessage = "default_error_message"
): void => {
  const tRP = "components.toast"; // tRP - translationRootPath

  const { isSucceeded, isCanceled, error } = response;
  let message = "";

  if (isSucceeded) {
    message = i18n.t(`${tRP}.${successMessage}`);
    if (showMessages === "all") toast.success(message, { autoClose: 10000 });
  } else if (OVERRIDEN_ERROR_MESSAGES.includes(error) && !isCanceled) {
    message = `${error}`;

    toast(message, { autoClose: 10000, className: "warning-toastifier" });
    throw message;
  } else if (error === "canceled" || isCanceled) {
    message = `${i18n.t(`${tRP}.default_canceled_message`)}`;

    toast(message, { autoClose: 10000, className: "cancel-toastifier" });
    throw message;
  } else if (error && !isCanceled) {
    message = `${i18n.t(`${tRP}.${errorMessage}`)} ${error ?? ""}`;
    toast.error(message, { autoClose: 10000 });
    throw message;
  }
};
